import IconButton from '@mui/material/IconButton';
import { iconMap } from '../maps/iconMap';
import { colors } from '../maps/colors';
import styled from "styled-components";


const LabelStyled = styled.div`
  position: absolute;
  color: #000;
  font-size: 9px;
  top: -22px;
`;
function IconBtn(props) {

    let { customtheme, classes = "", iconSize } = props;

    const Icon = iconMap[props.children];
    const propsStyle = props.style;

    let style = {};

    if (props.disabled) customtheme = 'disabled';

    switch (customtheme) {
        case 'custom':
            style = { ...propsStyle };
            break;
        case 'normal':
            break;
        case 'small-gray':
            style = { color: colors.GRAY1, ...propsStyle };
            break;
        case 'disabled':
            style = { color: colors.GRAY2, background: colors.GRAY3, opacity: 0.8, ...propsStyle };
            break;
        default:
            style = { color: colors.LIGHT_ORANGE, background: colors.GREEN, ...propsStyle };
    }

    return (
        <IconButton size={"normal"} {...props} style={{ ...style }} className={classes}>
            <Icon style={{ width: iconSize, height: iconSize }} />
            {props.label && (
                <LabelStyled>{props.label}</LabelStyled>
            )}
        </IconButton>
    )
}

export default IconBtn;